import { createContext, useContext } from 'react';
import { DEFAULT_CAM_LAYOUT, type CamLayoutConfig } from '@/lib/camLayouts';

export interface CamLayoutContextValue {
  /** Préférence du live : défaut du workspace, puis ce que le back publie dans la metadata de room. */
  preferred: CamLayoutConfig;
  /** Disposition réellement appliquée : la préférence adaptée au nombre de présentateurs. */
  effective: CamLayoutConfig;
  /** Changement demandé depuis une régie ; écrit par l'API, qui arbitre. */
  setPreferred: (config: CamLayoutConfig) => void;
  setEffective: (config: CamLayoutConfig) => void;
  /** Régie admin ou modérateur : peut modifier la disposition. */
  canEdit: boolean;
  /** Préférence reçue de la metadata de room (back = source de vérité). */
  applyFromRoom: (config: CamLayoutConfig) => void;
}

const noop = () => {};

/** Sans provider : disposition par défaut, réglages inertes. */
export const CamLayoutContext = createContext<CamLayoutContextValue>({
  preferred: DEFAULT_CAM_LAYOUT,
  effective: DEFAULT_CAM_LAYOUT,
  setPreferred: noop,
  setEffective: noop,
  canEdit: false,
  applyFromRoom: noop,
});

export const useCamLayout = (): CamLayoutContextValue => useContext(CamLayoutContext);
